import api from './api';

export const getQueue = async (params = {}) => {
  const response = await api.get('/queue/', { params });
  return response.data;
};

export const getQueueItem = async (id) => {
  const response = await api.get(`/queue/${id}`);
  return response.data;
};

export const createQueueItem = async (queueData) => {
  const response = await api.post('/queue/', queueData);
  return response.data;
};

export const updateQueueItem = async (id, queueData) => {
  const response = await api.put(`/queue/${id}`, queueData);
  return response.data;
};

export const deleteQueueItem = async (id) => {
  const response = await api.delete(`/queue/${id}`);
  return response.data;
};